import BASE_RULE from '../baseRule';
import {ContentsType, SearchTypeContents} from './constants';
import {ContentsRule} from './types';

export const contentsRuleDefaults: ContentsRule = {
	...BASE_RULE,
	elementType: SearchTypeContents,
	elementSubType1: ContentsType.MATCH_ALL_FRAGMENTS,
};

export default contentsRuleDefaults;
